import { render, staticRenderFns } from "./DebitEnquiryForm.vue?vue&type=template&id=06974a3f&scoped=true&"
import script from "./DebitEnquiryForm.vue?vue&type=script&lang=js&"
export * from "./DebitEnquiryForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06974a3f",
  null
  
)

export default component.exports